import React from 'react'
import { get } from 'lodash'
import axios from 'axios'
import { getToken } from '~/redux/user/tokens'
import './style.css'

class SSLCommerz extends React.Component {
  constructor(p) {
    super(p)
    this.state = {}
    this.onProceed = this.onProceed.bind(this)
  }
  getVal(key){
    return get(this.props.metadataMap, key)
  }

  render() {
    return (
      <div className="sslcom-form">
        <h3 className="title">
          {this.getVal('ccaHeading')}
        </h3>
        <input
          type="text"
          className="phone-number-input"
          ref={ el => this.phoneInputEl = el }
          placeholder={this.getVal('ccaPhone')}
          />
        { this.state.error && <div className="error">
          {this.state.error}
        </div> }
        <div
          className={ `button fat cta` + (this.state.processing ? ' processing' : '') }
          onClick={ this.onProceed } >
          {this.getVal('ccaCheckout')}
        </div>
        <p className="warning">{this.getVal('ccaWarning')}</p>
      </div>
    )
  }

  onProceed() {
    var plan = this.props.plan
    var phoneNumber = this.phoneInputEl.value

    if (!Number(phoneNumber) || (phoneNumber.length < 10 || phoneNumber.length > 11 ))
      return this.alert(this.getVal('ccaPhoneError'))

    this.setState({ processing: true })
    return (
      getToken()
        .then(token =>  axios({
          url: `${window.settings.apiBaseUrl}/sslcommerz/initiate-payment`,
          method: 'POST',
          params: { 'site': window.settings.internalName },
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json',
            'x-api-key': window.settings.baseAPIKey
          },
          data: {
            planId: plan.id,
            phone: phoneNumber
          }
        }))
        .then( r => { return r.data })
        .then( d => {
          if(d.GatewayPageURL){
            window.location.href = d.GatewayPageURL
          }else{
            this.alert('There was an error processing your request')
          }
        })
        .catch( e => {
          this.alert(e.message || this.getVal('ccaProcessingError'))
          console.error(e)
        })
        .then( _ => this.setState({ processing: false }))
    )
  }

  alert(msg) {
    this.setState({ error: msg })
    setTimeout(_ => this.setState({ error: null }), 2000)
  }
}

export default SSLCommerz